export const M_SET_SEARCHED = "M_SET_SEARCHED";
export const M_SET_SEARCH_IN_OUT = "M_SET_SEARCH_IN_OUT";
export const M_SET_MIN_PRICE = "M_SET_MIN_PRICE";
export const M_MAX_PRICE_IS_SET = "M_MAX_PRICE_IS_SET";
export const M_SET_OUT_HOTEL_MIN_PRICE = "M_SET_OUT_HOTEL_MIN_PRICE";
export const M_SET_API_URL = "M_SET_API_URL";
export const M_SET_API_ORIGIN = "M_SET_API_ORIGIN";
export const M_SET_LAST_MAP_REQUEST = "M_SET_LAST_MAP_REQUEST";
export const M_SET_HOTELS_FOR_MAP = "M_SET_HOTELS_FOR_MAP";
export const M_COLLAPSE_BY_HOTEL = "M_COLLAPSE_BY_HOTEL";
export const M_SET_SHOW_TOUR_RESULT_LIST = "M_SET_SHOW_TOUR_RESULT_LIST";
export const M_SET_SEARCH_LOADER_STATUS = "M_SET_SEARCH_LOADER_STATUS";
export const M_SET_SEARCH_SECOND_PARAMS_COUNTER = "M_SET_SEARCH_SECOND_PARAMS_COUNTER";
export const M_SET_FIRST_SEARCH = "M_SET_FIRST_SEARCH";
export const M_SET_FIRST_SEARCH_WITH_PARAMS = "M_SET_FIRST_SEARCH_WITH_PARAMS";
export const M_SET_CLICK_SEARCH = "M_SET_PRICE_TABLE";
export const M_SET_CONVERT_PRICE_FLAG = "M_SET_CONVERT_PRICE_FLAG"
export const M_SET_HOTEL_QUOTA = "M_SET_HOTEL_QUOTA"
export const M_SET_AVIA_QUOTA = "M_SET_AVIA_QUOTA"
export const M_SET_BUS_QUOTA = "M_SET_BUS_QUOTA"
export const M_SET_RAILWAY_QUOTA = "M_SET_RAILWAY_QUOTA"
export const M_SET_CHECK_FILTER_SELECT = "M_SET_CHECK_FILTER_SELECT"
export const M_SET_SHOW_CANCELLATION_POLICY = "M_SET_SHOW_CANCELLATION_POLICY";
export const M_SET_SHOW_TOTAL_PRICE = "M_SET_SHOW_TOTAL_PRICE";
export const M_SET_IS_AUTHENTICATED_RECENTLY = "M_SET_IS_AUTHENTICATED_RECENTLY";
export const M_SET_FILTER_PARAMS = "M_SET_FILTER_PARAMS"